export const areOnlyDigits = value => /^[0-9]*$/g.test(String(value))
